export default "__VITE_ASSET__080fa84f__"